module.exports = __webpack_public_path__ + "static/media/sundance0.bc8c74cd.jpg";